import axios from 'axios';
import { IEventsCollectionPayload, IEventsCollectionDto } from 'entities/Dashboard/Dashboard.models';

const basePath = 'events';

export const dashboardTransport = {
  getEventsCollection: (params: IEventsCollectionPayload): Promise<IEventsCollectionDto> =>
    axios.get(`${basePath}/queue`, { params }),
};
